import { render, staticRenderFns } from "./WhiteLabelGradient.vue?vue&type=template&id=2e2b90ba&scoped=true"
import script from "./WhiteLabelGradient.vue?vue&type=script&lang=js"
export * from "./WhiteLabelGradient.vue?vue&type=script&lang=js"
import style0 from "./WhiteLabelGradient.vue?vue&type=style&index=0&id=2e2b90ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2b90ba",
  null
  
)

export default component.exports